import { render, staticRenderFns } from "./auditCommodity.vue?vue&type=template&id=66a45c18&scoped=true"
import script from "./auditCommodity.vue?vue&type=script&lang=js"
export * from "./auditCommodity.vue?vue&type=script&lang=js"
import style0 from "./auditCommodity.vue?vue&type=style&index=0&id=66a45c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a45c18",
  null
  
)

export default component.exports